module.exports = __webpack_public_path__ + "static/media/achievement-shoe-of-the-week.5be3a7ec.svg";